import {GetObjectCommand, GetObjectCommandInput, PutObjectCommand, S3Client} from "@aws-sdk/client-s3";
import {Credentials} from "@aws-sdk/types";
import {FamilyMemberStats} from "./Statistics";
import {Readable} from "stream";

// const config : Credentials = {
//     bucketName: process.env.REACT_APP_BUCKET_NAME,
//     dirName: process.env.REACT_APP_DIR_NAME /* optional */,
//     region: process.env.REACT_APP_REGION,
//     accessKeyId: process.env.REACT_APP_ACCESS_ID,
//     secretAccessKey: process.env.REACT_APP_ACCESS_KEY,
// };

class MyCredentials implements Credentials {

    constructor() {
        this.accessKeyId = process.env.REACT_APP_ACCESS_ID!;
        this.secretAccessKey = process.env.REACT_APP_SECRET_ACCESS_KEY!;
    }

    readonly accessKeyId: string;
    readonly secretAccessKey: string;
}

let hardcodedCredentials = new MyCredentials();

const s3 = new S3Client({ region: "eu-north-1", credentials: hardcodedCredentials } );


export async function UploadMember(name : string, statistics : FamilyMemberStats) {
    const uploadParams = {
        Bucket: process.env.REACT_APP_BUCKET_NAME,
        Key: `svarburk/${name}.json`,
        Body: JSON.stringify(statistics)
    };
    await s3.send(new PutObjectCommand(uploadParams));

    const uploadParams2 = {
        Bucket: process.env.REACT_APP_BUCKET_NAME,
        Key: `svarburk/log/${name}_${new Date().getTime()}.json`,
        Body: JSON.stringify(statistics)
    };
    await s3.send(new PutObjectCommand(uploadParams2));
}

async function streamToString2 (stream: ReadableStream | Readable): Promise<string> {
    if (stream instanceof Readable) {
        return streamToString(stream)
    }
    return new Promise((resolve, reject) => {
        let text = "";
        const decoder = new TextDecoder("utf-8");

        const reader = stream.getReader();

        const processRead = ({ done, value } : ReadableStreamDefaultReadResult<any>) => {
            if (done) {
                // resolve promise with chunks
                console.log("done");
                // resolve(Buffer.concat(chunks).toString("utf8"));
                resolve(text);
                return;
            }

            text += decoder.decode(value);

            // Not done, keep reading
            reader.read().then(processRead);
        };

        // start read
        reader.read().then(processRead);
    });
};

async function streamToString (stream: Readable): Promise<string> {
    return await new Promise((resolve, reject) => {
        const chunks: Uint8Array[] = [];
        stream.on('data', (chunk) => chunks.push(chunk));
        stream.on('error', reject);
        stream.on('end', () => resolve(Buffer.concat(chunks).toString('utf-8')));
    });
}

export async function GetCurrentStats(name : string) : Promise<FamilyMemberStats> {

    let getParams : GetObjectCommandInput = {
        Bucket: process.env.REACT_APP_BUCKET_NAME,
        Key: `svarburk/${name}.json`
    };

    let output = await s3.send(new GetObjectCommand(getParams));
    let body = await streamToString2(output.Body as ReadableStream | Readable);
    return JSON.parse(body)
}
